import {Pipe, PipeTransform} from '@angular/core';

@Pipe ({
  name: 'skill'
})
export class SkillLevelPipe implements PipeTransform {
  transform(value: any, limit?: number) {
    if (value != null && value === 'cas') {
      return 'Casual';
    }
    if (value != null && value === 'com') {
      return 'Competitive';
    }
    return value;
  }
}
